<template>
  <div :class="['text-' + pos, classes]">
    <p :class="['p1', (sombra ? 'p1_sombra' : '')]">
      <i :class="['bi','bi-'+icon]" v-if="icon"></i>
      {{ titulo }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'Titulo',
  components: {

  },
  props: {
    titulo: String,
    pos: {
      default: 'center'
    },
    theme: {
      default: 'light'
    },
    sombra: {
      default: true
    },
    classes: String,
    icon: String,
  },
  data() {
    return {
      corTexto: String,
      corTextSec: String,
      paramP1: String,
    }
  },
  mounted() {
    switch (this.theme) {
      case 'dark':
        this.corTexto = `var(--cor-titulo-primario)`;
        this.corTextSec = `rgb(45, 61, 77, 0.3)`;
        this.paramP1 = '';
        break;
      case 'light':
        this.corTexto = `var(--cor-base-texto)`;
        this.corTextSec = `rgb(230, 230, 230, 0.6)`;
        this.paramP1 = `2px 2px 2px var(--cor-titulo-primario)`;
        break;
      default:
        this.corTexto = `var(--cor-base-texto)`;
        this.corTextSec = `rgb(230, 230, 230, 0.6)`;
        this.paramP1 = `2px 2px 2px var(--cor-titulo-primario)`;
        break;
    }
  }
}
</script>

<style scoped>
@media (max-width: 999px) {
  .p1 {
    font-size: 1.3rem;
    /* margin-top: -60px; */
  }

  .p2 {
    font-size: 2.6rem;
  }
}

@media (min-width: 1000px) {
  .p1 {
    font-size: 2rem;
    /* margin-top: -90px; */
  }

  .p2 {
    font-size: 5rem;
  }
}

/* .double {
  border-bottom: 3px solid var(--cor-titulo-primario);
  width: 50%;
} */

.p1 {
  font-weight: 600;
  color: v-bind('corTexto');
  /* font-family: 'Poppins, sans-serif'; */
}

.p1_sombra {
  text-shadow: v-bind(paramP1);
}

.p2 {
  color: v-bind(corTextSec);
  font-family: 'Poppins, sans-serif';
  font-weight: 700;
}
</style>